import Section from '@/src/components/Section/Section'
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import { setMetaTags } from '../components/utils/manage-tags'
import { getPagesByCategory } from '../contentful/getPages'
import { getDictionary, getImagePath, isHot97 } from '../dictionary'

export async function getServerSideProps({ req }) {

    const features = await getPagesByCategory(1000, 'features')

    return {
        props: {
            features: features,
            host: req.headers.host
        },
    }
}

function getFirstParagraph(content) {
    const regex = /<p>(.*?)<\/p>/
    const paragraphs = regex.exec(content)
    return (paragraphs) ? paragraphs[0] : ''
}

function Features({ features, host }) {
    return (
        <>
            <Head>
                {setMetaTags(host, {}, '/features')}
            </Head>
            <Section
                key={`Features at ${getDictionary('websiteName')}`}
                title={`Features at ${getDictionary('websiteName')}`}
                sectionStyle='m-auto w-[80%] lg:w-[50%] md:w-[70%] sm:w-[70%] pt-4'
                showHeader={true}
            >
                <main id='main'>
                    <section className='w-full flex flex-col items-center'>
                        {
                            features.length === 0
                                ? (
                                    <div className='w-full h-[100vh]'>
                                        <h1 className='font-[Judge] text-hot-yellow'>No features yet.</h1>
                                    </div>
                                ) :
                                features.map((feature, index) => {
                                    const imgURL = feature.fields.banner?.fields?.file ? `https:${feature.fields.banner.fields.file.url}` : getImagePath('website-logo.png')
                                    return (
                                        <div key={feature.sys.id} className='pb-12'>
                                            <Link prefetch={false} className={'text-3xl text-body'}
                                                href={feature.fields.category + '/' + feature.fields.url}
                                                rel='noreferrer noopener'>
                                                <h2 className='text-content font-[Judge] text-5xl text-center pb-5'>
                                                    {feature.fields.title}
                                                </h2>
                                                <figure className='py-2'>
                                                    <Image
                                                        loading='lazy'
                                                        src={imgURL}
                                                        alt='jjq'
                                                        className='lazyloaded'
                                                        sizes='(max-width: 1024px) 100vw, 1024px'
                                                        srcSet={
                                                            imgURL +
                                                            '?w=1024, ' +
                                                            imgURL +
                                                            '?w=600'
                                                        }
                                                        data-ll-status='loaded'
                                                        width='1024'
                                                        height='725'
                                                    />
                                                </figure>
                                            </Link>
                                            <div className='text-content'
                                                dangerouslySetInnerHTML={{ __html: getFirstParagraph(feature.fields.content) }}>
                                            </div>
                                            {feature.fields.actionUrl ?
                                                <Link prefetch={false} className={'text-3xl text-body'}
                                                    href={feature.fields.actionUrl}
                                                    target={'_blank'}
                                                    rel='noreferrer noopener'>
                                                    <button
                                                        className={`hidden lg:flex btn box rounded-none ${isHot97() ? 'btn-warning' : 'btn-error'} btn-outline btn-active btn-hot-yellow text-6xl flex-column p-4 content-center items-center w-full h-24`}>
                                                        Go
                                                    </button>
                                                    <button
                                                        className={`flex lg:hidden btn box rounded-lg ${isHot97() ? 'btn-warning' : 'btn-error'} btn-outline btn-active btn-hot-yellow text-6xl flex flex-column p-4 content-center items-center w-1/2 h-12`}>
                                                        <svg xmlns='http://www.w3.org/2000/svg' width='27' height='24'
                                                            viewBox='0 0 27 24' fill='none'>
                                                            <path
                                                                d='M3 3C1.34531 3 0 4.34531 0 6V9C0 9.4125 0.346875 9.73594 0.735937 9.87188C1.61719 10.1766 2.25 11.0156 2.25 12C2.25 12.9844 1.61719 13.8234 0.735937 14.1281C0.346875 14.2641 0 14.5875 0 15V18C0 19.6547 1.34531 21 3 21H24C25.6547 21 27 19.6547 27 18V15C27 14.5875 26.6531 14.2641 26.2641 14.1281C25.3828 13.8234 24.75 12.9844 24.75 12C24.75 11.0156 25.3828 10.1766 26.2641 9.87188C26.6531 9.73594 27 9.4125 27 9V6C27 4.34531 25.6547 3 24 3H3ZM6 8.25V15.75C6 16.1625 6.3375 16.5 6.75 16.5H20.25C20.6625 16.5 21 16.1625 21 15.75V8.25C21 7.8375 20.6625 7.5 20.25 7.5H6.75C6.3375 7.5 6 7.8375 6 8.25ZM4.5 7.5C4.5 6.67031 5.17031 6 6 6H21C21.8297 6 22.5 6.67031 22.5 7.5V16.5C22.5 17.3297 21.8297 18 21 18H6C5.17031 18 4.5 17.3297 4.5 16.5V7.5Z'
                                                                fill='black' />
                                                        </svg>
                                                        <span
                                                            className={`text-3xl pl-3 font-[Judge]`}>Go</span>
                                                    </button>
                                                </Link>
                                                : null
                                            }
                                            {
                                                features.length > (index + 1) ?
                                                    <hr className='border-b-2 border-content w-full py-6' />
                                                    : null
                                            }
                                        </div>
                                    )
                                })
                        }
                    </section>
                </main>
            </Section>
        </>
    )
}

export default Features
